module.exports = __webpack_public_path__ + "img/SLIDERS.fcf3f097.svg";